module.exports = __webpack_public_path__ + "static/img/Snipaste_2022-01-22_23-15-57.2f6ac7ef.png";